var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-127 -709)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    transform: "translate(127 709)",
    fill: "#0db0f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.629,7.358c.012.175.012.349.012.524A11.379,11.379,0,0,1,6.184,19.339,11.38,11.38,0,0,1,0,17.531a8.331,8.331,0,0,0,.972.05,8.065,8.065,0,0,0,5-1.72,4.034,4.034,0,0,1-3.765-2.793,5.078,5.078,0,0,0,.761.062,4.259,4.259,0,0,0,1.06-.137A4.028,4.028,0,0,1,.8,9.041v-.05a4.056,4.056,0,0,0,1.82.511A4.033,4.033,0,0,1,1.371,4.116a11.447,11.447,0,0,0,8.3,4.214,4.546,4.546,0,0,1-.1-.923,4.031,4.031,0,0,1,6.969-2.755A7.928,7.928,0,0,0,19.1,3.68,4.016,4.016,0,0,1,17.33,5.9a8.073,8.073,0,0,0,2.319-.623A8.656,8.656,0,0,1,17.629,7.358Z",
    transform: "translate(137.176 717.64)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTwitter);
export default __webpack_public_path__ + "static/media/shareTwitter.194249530f460c5335428b29b9e42f55.svg";
export { ForwardRef as ReactComponent };